// 시공사 만들기 초안 자리(sessionStorage) — 사용자별로 가르고, 로그아웃하면 이 탭의 초안을 전부 지운다.

export const ONBOARDING_DRAFT_PREFIX = "buildpy:onboarding-draft";

export const onboardingDraftKey = (userId: string): string => `${ONBOARDING_DRAFT_PREFIX}:${userId}`;

export const readOnboardingDraft = (userId: string): string | null => {
  try {
    return window.sessionStorage.getItem(onboardingDraftKey(userId));
  } catch {
    return null;
  }
};

export const writeOnboardingDraft = (userId: string, value: string): void => {
  try {
    window.sessionStorage.setItem(onboardingDraftKey(userId), value);
  } catch {
    // 못 적으면 돌아왔을 때 빈 칸부터 — 만들기에는 영향 없다.
  }
};

export const removeOnboardingDraft = (userId: string): void => {
  try {
    window.sessionStorage.removeItem(onboardingDraftKey(userId));
  } catch {
    // 못 지우면 다음 마법사가 이 값으로 시작할 뿐이다(같은 사용자만).
  }
};

// 로그아웃 — 사용자 구분 전 옛 키(접두사 그대로)까지 이 탭의 초안을 전부 지운다.
export const clearOnboardingDrafts = (): void => {
  try {
    const storage = window.sessionStorage;
    const keys: string[] = [];
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i);
      if (key && key.startsWith(ONBOARDING_DRAFT_PREFIX)) keys.push(key);
    }
    for (const key of keys) storage.removeItem(key);
  } catch {
    // 저장소를 못 열면 지울 것도 없다.
  }
};
